export const GET_ACTIVITY_DATA = 'activity/get_activity_data'
export const SET_ACTIVITY_DATA = 'activity/set_activity_data'
export const SET_ACTIVITY_SELECT_DATA= 'activity/set_activity_select_data'
export const GET_ACTIVITY_SELECT_DATA= 'activity/get_activity_select_data'
